export const RESIZE_HANDLE_WIDTH_IN_PX = 18
export const MIN_BAR_WIDTH_IN_PX = 9
